module.exports = __webpack_public_path__ + "img/ibs_05.6d5e39e1.png";